import DivisionIcon from '@material-ui/icons/TurnedIn';
import DivisionList from './DivisionList';
const DivisionModule = {
    list: DivisionList,
    icon: DivisionIcon,
}; export default DivisionModule;